import React from 'react';
import clsx from 'clsx';
import { Button } from '../../../components/ui/Button';

// Whole class names: Tailwind only builds the ones it finds written out.
const COLUMNS = { 2: 'grid-cols-2', 3: 'grid-cols-3' };

/**
 * Tabs side by side, two or three, each a row to tap; the chosen one is
 * filled green (`aria-pressed`). A tab that knows how many it holds says so:
 * «Desde recepción · 3». A `disabled` tab cannot be tapped; the screen says why.
 *
 * `<OperatorTabs tabs={[{ value: 'tasks', label: 'Tareas', count: 4 }, …]} active={tab}
 *   onChange={choose} testId="home-tab" dataKey="tab" label="Qué hacer" />`
 *
 * @param {object} props
 * @param {Array<{value: string, label: string, count?: number|null, disabled?: boolean}>} props.tabs
 * @param {string} props.active - The `value` of the chosen tab.
 * @param {(value: string) => void} props.onChange
 * @param {string} props.testId - Every tab's `data-testid`.
 * @param {string} props.dataKey - The `data-*` attribute that carries each tab's value: `tab` is `data-tab`.
 * @param {string} props.label - What the group is, for screen readers.
 * @param {string} [props.groupTestId] - The group's `data-testid`.
 */
export const OperatorTabs = ({ tabs, active, onChange, testId, dataKey, label, groupTestId }) => (
  <div
    role="group"
    aria-label={label}
    data-testid={groupTestId}
    className={clsx('grid gap-2', COLUMNS[tabs.length] ?? COLUMNS[2])}
  >
    {tabs.map((tab) => {
      const counted = tab.count != null;
      return (
        <Button
          key={tab.value}
          variant="choice"
          aria-pressed={tab.value === active}
          disabled={Boolean(tab.disabled)}
          data-testid={testId}
          {...{ [`data-${dataKey}`]: tab.value }}
          data-count={counted ? tab.count : ''}
          onClick={() => onChange(tab.value)}
        >
          <span className="block text-center text-sm font-bold">
            {counted ? `${tab.label} · ${tab.count}` : tab.label}
          </span>
        </Button>
      );
    })}
  </div>
);
